module.exports = __webpack_public_path__ + "static/media/otter.fc15baf5.svg";